import React, { useState } from 'react';

import { chosenOptions, groupRule, isComplete, QrModifierOption, QrProduct, toggleOption } from './modifierChoice';

type Props = {
    product: QrProduct;
    onCancel: () => void;
    onConfirm: (options: QrModifierOption[]) => void;
};

// Pregunta los modificadores del producto antes de agregarlo al pedido
const ModifierModal: React.FC<Props> = ({ product, onCancel, onConfirm }) => {
    const groups = product.modifierGroups ?? [];
    const [selection, setSelection] = useState<Record<number, number[]>>({});

    const canConfirm = groups.every(g => isComplete(g, selection[g.id] ?? []));
    const extras = chosenOptions(groups, selection).reduce((sum, o) => sum + Number(o.price ?? 0), 0);

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onCancel}>
            <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content border-0">
                    <div className="modal-header">
                        <h5 className="modal-title mb-0">{product.name}</h5>
                        <button type="button" className="btn-close" onClick={onCancel} />
                    </div>
                    <div className="modal-body p-0">
                        {groups.map(group => {
                            const selected = selection[group.id] ?? [];
                            const single = group.maxSelect === 1;
                            const missing = group.required && !isComplete(group, selected);
                            return (
                                <div key={group.id}>
                                    <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2">
                                        <strong>{group.name}</strong>
                                        <small className={missing ? 'text-danger' : 'text-muted'}>{groupRule(group)}</small>
                                    </div>
                                    {group.options.map(option => (
                                        <label key={option.id} className="d-flex align-items-center gap-2 px-3 py-2 border-bottom" style={{ cursor: 'pointer' }}>
                                            <input
                                                type={single ? 'radio' : 'checkbox'}
                                                className="form-check-input mt-0"
                                                name={`group-${group.id}`}
                                                checked={selected.includes(option.id)}
                                                onChange={() => setSelection(s => ({ ...s, [group.id]: toggleOption(group, s[group.id] ?? [], option.id) }))}
                                            />
                                            <span className="flex-grow-1">{option.name}</span>
                                            {option.price > 0 && <small className="text-muted">+ ₡ {Number(option.price).toLocaleString()}</small>}
                                        </label>
                                    ))}
                                </div>
                            );
                        })}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" onClick={onCancel}>Cancelar</button>
                        <button type="button" className="btn btn-success" disabled={!canConfirm}
                            onClick={() => onConfirm(chosenOptions(groups, selection))}>
                            Agregar{extras > 0 ? ` (+ ₡ ${extras.toLocaleString()})` : ''}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModifierModal;
